"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aboutHeaderInfoIcon = exports.aboutHeaderPlaceholderText = exports.aboutHeaderDescriptionAndTagsContent = exports.aboutHeaderDescriptionAndTags = exports.aboutHeaderConnectionTypeDetailIcon = exports.aboutHeaderConnectionTypeDetailText = exports.aboutHeaderConnectionTypeDetailItem = exports.aboutHeaderDetailItem = exports.aboutHeaderDetailLabel = exports.aboutHeaderDetailsTextElide = exports.aboutHeaderDetailsWrapper = exports.aboutHeader = void 0;
var widgets_1 = require("@tableau/widgets");
var LayoutStyles_1 = require("./LayoutStyles");
var StyleFunctions_1 = require("./StyleFunctions");
var SubplaceStyles_1 = require("./SubplaceStyles");
var VizPortalStyles_1 = require("./VizPortalStyles");
var Spacing = widgets_1.TabStyles.Spacing;
var FontSizes = widgets_1.TabStyles.Typography.Sizing;
var FontColors = widgets_1.TabStyles.Typography.Color;
var descriptionAndTagsMaxHeight = '100px';
var descriptionAndTagsMaxWidth = 'calc(100vw - 606px)';
exports.aboutHeader = StyleFunctions_1.cssClass('aboutHeaderClass', SubplaceStyles_1.PaneTitleTextStyle);
exports.aboutHeaderDetailsWrapper = StyleFunctions_1.cssClass('aboutHeaderDetailsWrapperClass', {
    paddingRight: Spacing.ExtraLargeSpace,
    paddingBottom: Spacing.ExtraLargeSpace,
    paddingLeft: Spacing.ExtraLargeSpace,
    color: FontColors.Primary,
    fontSize: FontSizes.Large
});
exports.aboutHeaderDetailsTextElide = StyleFunctions_1.cssClass('aboutHeaderDetailsTextElideClass', LayoutStyles_1.elideTextStyle);
exports.aboutHeaderDetailLabel = StyleFunctions_1.cssClass('aboutHeaderDetailLabel', VizPortalStyles_1.MetadataLabelColor, {
    paddingBottom: Spacing.DefaultSpace
});
exports.aboutHeaderDetailItem = StyleFunctions_1.cssClass('aboutHeaderDetailItem', {
    paddingTop: Spacing.MediumSpace,
    paddingLeft: Spacing.LargeSpace,
    paddingRight: Spacing.MediumSpace,
    flexShrink: 1,
    maxWidth: 275,
    minWidth: 0,
});
exports.aboutHeaderConnectionTypeDetailItem = StyleFunctions_1.cssClass('aboutHeaderConnectionTypeDetailItem', {
    flexShrink: 0,
});
exports.aboutHeaderConnectionTypeDetailText = StyleFunctions_1.cssClass('aboutHeaderConnectionTypeDetailItem', {
    flexShrink: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
exports.aboutHeaderConnectionTypeDetailIcon = StyleFunctions_1.cssClass('aboutHeaderConnectionTypeDetailItem', {
    flexShrink: 0,
});
exports.aboutHeaderDescriptionAndTags = StyleFunctions_1.cssClass('aboutHeaderDescriptionAndTags', {
    paddingTop: Spacing.MediumSpace,
    paddingLeft: Spacing.LargeSpace,
});
exports.aboutHeaderDescriptionAndTagsContent = StyleFunctions_1.cssClass('aboutHeaderDescriptionAndTagsContent', {
    maxHeight: descriptionAndTagsMaxHeight,
    maxWidth: descriptionAndTagsMaxWidth,
    overflow: 'auto'
});
exports.aboutHeaderPlaceholderText = StyleFunctions_1.cssClass('PlaceholderTextCell', LayoutStyles_1.elideTextStyle, {
    fontStyle: 'italic',
    color: FontColors.Secondary,
});
exports.aboutHeaderInfoIcon = StyleFunctions_1.cssClass('aboutHeaderInfoIcon', {
    marginLeft: Spacing.DefaultSpace,
    verticalAlign: 'text-bottom'
});
//# sourceMappingURL=AboutHeaderDetailsStyles.js.map